import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#F5F5F5';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderBottomColor: borderColor,
    backgroundColor: '#F5F5F5',
    borderBottomWidth: 1,
    alignItems: 'center',
   
    height: 24,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  refrence: {
    width: '20%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    fontSize: 9,
    paddingLeft: 5,
    
  },
  description: {
    width: '25%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    fontSize: 9,
    paddingLeft: 5,
  },
  details: {
    width: '25%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    fontSize: 9,
   paddingLeft: 5,
  },
  service_date: {
    width: '20%',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    fontSize: 9,
   paddingLeft: 5,
  },
  amount: {
    width: '10%',
    fontSize: 9,
   
  },
});

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.refrence}>Booking ID</Text>
    <Text style={styles.description}>Booking Item</Text>
    <Text style={styles.details}>Details</Text>
    <Text style={styles.service_date}>Service Date</Text>
    <Text style={styles.amount}>Amount</Text>
  </View>
);

export default InvoiceTableHeader;
